import './style/index.js';

import _ImageViewer from './ImageViewer';

export type { ImageViewerProps } from './ImageViewer';

export const ImageViewer = _ImageViewer;

export default ImageViewer;
